import http from './http';

export default {
  all() {
    return http().get(`/v1/buying_offers`);
  },
  get(id) {
    return http().get(`/v1/buying_offers/${id}`);
  },
  create(data) {
    return http().post(`/v1/buying_offers`, data);
  },
  update(data) {
    return http().put(`/v1/buying_offers/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/buying_offers/${id}`);
  },
}
